import React from "react";
import { FaTimes } from "react-icons/fa";
import Button from "../../element/forms/Button";

type IModal = {
  title?: string | React.ReactNode;
  open: boolean;
  children: React.ReactNode;
  variant?: string;
  onClose: () => void;
  onOkClick: () => void;
  isLoading?: boolean;
  hasButton?: boolean;
};

const Modal: React.FC<IModal> = ({
  title,
  open,
  children,
  variant,
  onClose,
  onOkClick,
  isLoading = false,
  hasButton = true,
}) => {
  const modalSize = () => {
    switch (variant) {
      case "large":
        return "w-[62.5rem] h-[80vh] md:h-auto";
      case "medium":
        return "w-[46.875rem]";
      default:
        return "w-[31.25rem]";
    }
  };
  return (
    <div
      className={`fixed inset-0 flex items-center justify-center px-6 xl:px-0
        transition-opacity duration-300 ease-in-out z-50 ${open ? "opacity-100 visible bg-black/50" : "opacity-0 invisible"}`}
      onClick={onClose} // Close modal when clicking outside
    >
      <div
        className={`relative ${modalSize()} bg-white border border-gray-200/30 rounded-xl shadow-2xl
  transform transition-transform duration-300 ease-in-out overflow-hidden max-h-[90vh] flex flex-col ${open ? "scale-100" : "scale-75 opacity-0"}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header — stays fixed */}
        <div className="text-xl font-semibold border-b border-b-gray-200/30 px-6 py-3 shrink-0">
          {title}
        </div>
        <div className="absolute top-4 right-6">
          <FaTimes
            onClick={onClose}
            size={24}
            color="#9CA3AF"
            className="cursor-pointer"
          />
        </div>

        {/* Body — scrolls */}
        <div className="p-6 overflow-x-hidden overflow-y-auto flex-1">
          {children}
        </div>

        {/* Footer — stays fixed */}
        {hasButton && (
          <div className="flex justify-end gap-x-2 border-t border-t-gray-200/30 px-6 py-3 shrink-0">
            <Button
              title="Close"
              onClick={onClose}
              className="bg-transparent text-black hover:text-primary-500 border border-gray-500 hover:!border-primary-500"
            />
            <Button title="Submit" onClick={onOkClick} loading={isLoading} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
